import { render, staticRenderFns } from "./GetStartedButton.vue?vue&type=template&id=38e0a44c&scoped=true&"
import script from "./GetStartedButton.vue?vue&type=script&lang=js&"
export * from "./GetStartedButton.vue?vue&type=script&lang=js&"
import style0 from "./GetStartedButton.vue?vue&type=style&index=0&id=38e0a44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0a44c",
  null
  
)

export default component.exports